import { HistoricoSection } from '../HistoricoSection'
import { HistoricoItemCard } from '../HistoricoItemCard'
import { FormularioAtendimentoList } from '../../../../avaliacoes/avaliacoes-pendentes-list/core/_models'

import { useHistoricoPaciente } from '../../hooks/useHistoricoPaciente'
import { downloadAvaliacao } from '../../../../avaliacoes/avaliacoes-list/core/_requests'
import {
  downloadArquivo,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import Swal from 'sweetalert2'

type Props = {
  /** Vem por prop (e não `useParams`): a seção é aberta num modal, que fica fora das rotas. */
  pacienteId: number
}

export const AvaliacoesSection = ({ pacienteId }: Props) => {
  // const { showModal } = useModal()

  const { fetchAvaliacoes } = useHistoricoPaciente(String(pacienteId))

  // const showAvaliacao = (formulario: FormularioAtendimentoList) =>
  //   showModal({
  //     title: `Avaliação de ${formulario?.paciente.pessoa?.nome}`,
  //     content: <FormularioViewModal />,
  //     fetchers: {
  //       respostas: async () => {
  //         const formularioRespondido = await getFormularioAtendimento(
  //           formulario.atendimento.id,
  //           formulario.id
  //         )
  //         return formularioRespondido.respostas
  //       },
  //     },
  //   })

  const handleDownload = async (formulario: FormularioAtendimentoList) => {
    try {
      showAlertLoading()
      const arquivo = await downloadAvaliacao(formulario.atendimento.id, formulario.id)
      downloadArquivo(arquivo)
      Swal.close()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <HistoricoSection
      title='Avaliações'
      fetcher={fetchAvaliacoes}
      renderItem={(item) => (
        <HistoricoItemCard
          key={item.id}
          title={item.formulario.nome}
          subtitle={item.dataFormatada}
          onClick={() => handleDownload(item)}
        />
      )}
    />
  )
}
